import { ReactComponent as CrossIcon } from './cross.svg';

export const SvgIcons = {
  CrossIcon,
};
